import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { FeedbackCategoryOption } from '@tabify/models/types';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api.baseUrl;

  private readonly categoriesCache = new Map<string, FeedbackCategoryOption[]>();

  /**
   * Labels are server-localised, so the cache is keyed by language.
   * GET /api/v1/feedback/categories
   */
  getCategories(language: string): Observable<FeedbackCategoryOption[]> {
    const cached = this.categoriesCache.get(language);
    if (cached) {
      return of(cached);
    }

    return this.http
      .get<FeedbackCategoryOption[]>(`${this.baseUrl}/api/v1/feedback/categories`)
      .pipe(tap((options) => this.categoriesCache.set(language, options)));
  }
}
